import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Card, Form, InputGroup } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NewStudent = () => {

  const initialFormData = {
    // PERSONAL
    section_id: "",
    academic_year1: "",
    academic_year2: "",
    stud_first_name: "",
    stud_middle_name: "",
    stud_last_name: "",
    gr_no: "",
    aadhar_no: "",
    student_id: "",
    form_no: "",
    birth_date: "",
    birth_place: "",
    gender_id: "",
    mthly_install: "I",
    curr_std_id: "",
    curr_div_id: "",
    status: "A",
    adm_std_id: "",
    adm_div_id: "",
    adm_date: "",
    email_for_corrsp: "",
    mobile_for_sms: "",
    opt_sub_id: "",
    stud_pic: "",
    full_academic: "Y",

    // COMMUNICATION
    curr_address1: "",
    curr_address2: "",
    curr_pin_code: "",
    curr_telephone: "",
    perm_address1: "",
    perm_address2: "",
    perm_state_id: "0",
    perm_district: "",
    perm_pin_code: "",
    perm_country: "", // no input field
    perm_taluka: "",
    perm_telephone: "", // no input field

    //PARENTS 
    father_first_name: "",
    father_last_name: "",
    father_email_id: "",
    father_cell_no: "",
    father_qual_id: "",
    father_occp_id: "",
    father_designation: "",
    father_age: "",
    father_firm_name: "",
    father_firm_addr: "",
    father_firm_tel: "",
    father_aadhar: "",
    family_pic: "",
    mother_first_name: "",
    mother_last_name: "",
    mother_email_id: "",
    mother_cell_no: "",
    mother_qual_id: "",
    mother_occp_id: "",
    mother_designation: "",
    mother_age: "",
    mother_firm_name: "",
    mother_firm_addr: "",
    mother_firm_tel: "",
    mother_aadhar: "",
    parent_pic: '',

    // OTHER
    religion_id: "",
    caste_id: "",
    sub_caste_id: "",
    house_id: "",
    nationality: "INDIAN",
    mother_tongue: "URDU",
    last_school_name: "",
    last_school_std: "",
    last_school_addr1: "",
    last_school_addr2: "",
    leave_cert_id: "",
    prev_gr_no: "",
    prev_stud_sec_id: "",
    next_gr_no: "",
    next_stud_sec_id: "",
    //// Medical
    blood_group: "",
    hearing: "N",
    epilepsy: "N",
    wear_glasses: "N",
    glasses_details: "",
    height_admission: "",
    height_current: "",
    weight_admission: "",
    weight_current: "",
    chronic_illness: "N",
    illness_details: "",
    allergies: "N",
    allergy_details: "",
    asthma: "N",
    diabetes: "N",
    heart_condition: "N",
    heart_details: "",
    regular_medication: "N",
    medical_remarks: "",
    emg_cont_name: "",
    emg_cont_relation: "",
    emg_cont_number: "",
    doctor_name: "",
    doctor_number: "",
  };

  const [isEditable, setIsEditable] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [file, setFile] = useState(null);
  const [parentfile, setParentFile] = useState(null);

  const [lcbcFile, setLCBCFile] = useState(null);
  const [aadharFile, setAadharFile] = useState(null);

  const [savedImage, setSavedImage] = useState("");
  const fileInputRef = useRef(null);
  const parentfileInputRef = useRef(null);
  const [errors, setErrors] = useState({});

  // DROPDOWNS
  const [ddlSections, setDdlSections] = useState([]);
  const [ddlStandards, setDdlStandards] = useState([]);
  const [ddlDivisions, setDdlDivisions] = useState([]);

  const [commResult, setCommResult] = useState(null);

  const [ddlGender, setDdlGender] = useState([]);
  const [ddlStatus, setDdlStatus] = useState([]);
  const [ddlMthlyInst, setDdlMthlyInst] = useState([]);

  const [ddlQualifications, setDdlQualifications] = useState([]);
  const [ddlOccupations, setDdlOccupations] = useState([]);

  const [ddlReligions, setDdlReligions] = useState([]);
  const [ddlCastes, setDdlCastes] = useState([]);
  const [ddlSubCastes, setDdlSubCastes] = useState([]);
  const [ddlHouses, setDdlHouses] = useState([]);
  const containerRef = useRef(null);
  const [showButton, setShowButton] = useState(false);
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [pdfURL, setPdfURL] = useState(null);
  const [aadharpdfURL, setAadharPdfURL] = useState(null);

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);

      const comm_result = await axios.get(`${BASE_URL}/api/ddl_common_master`);

     // setCommResult(comm_result.data);

      const genderData = comm_result.data.filter(item => item.comm_type === 'G');
      const qualificationData = comm_result.data.filter(item => item.comm_type === 'QUAL');
      const occupationData = comm_result.data.filter(item => item.comm_type === 'OCC');
      const religionData = comm_result.data.filter(item => item.comm_type === 'RLG');
      const houseData = comm_result.data.filter(item => item.comm_type === 'HSE');
      const castesData = comm_result.data.filter(item => item.comm_type === 'CST');
      const subcastesData = comm_result.data.filter(item => item.comm_type === 'SCST');

      setDdlGender(genderData);
      setDdlQualifications(qualificationData);
      setDdlOccupations(occupationData);
      setDdlReligions(religionData);
      setDdlHouses(houseData);
      setDdlCastes(castesData);
      setDdlSubCastes(subcastesData);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);

      setDdlAcademicYears(year_result.data);

      setDdlStatus([
        { id: "A", name: "Active" },
        { id: "I", name: "Inactive" }
      ]);

      setDdlMthlyInst([
        { id: "I", name: "Installments" },
        { id: "M", name: "Monthly" }
      ]);

      // setDdlAcademicYear([
      //   { id: "2023-2024", y1: 2023, y2: 2024 },
      //   { id: "2024-2025", y1: 2024, y2: 2025 },
      //   { id: "2025-2026", y1: 2025, y2: 2026 }
      // ]);

    } catch (err) {
      console.error(err);
    }
  };

  /// To Populate Standard on chnage of Section
  useEffect(() => {

    if (!formData.section_id) return;

    const fetchStandards = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_standards`, { params: { p_Section_Id: formData.section_id } });
        setDdlStandards(res.data || []);
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    };

    fetchStandards();

  }, [formData.section_id]);

  /// To Populate Division on change of Standard
  useEffect(() => {

    if (!formData.curr_std_id) return;

    const fetchDivision = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_division`, { params: { p_Std_Id: formData.curr_std_id } });
        setDdlDivisions(res.data || []);
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    };

    fetchDivision();

  }, [formData.curr_std_id]);

  const handleChange = (e) => {

    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === 'academic_year1') {
       setFormData(prev => ({ ...prev, academic_year2: Number(value) + 1 }));
    } 
    // else if (name === 'religion_id') {
    //   setDdlCastes([]);
    //   setDdlSubCastes([]);
    //   setFormData(prev => ({ ...prev, caste_id: "" }));
    //   setFormData(prev => ({ ...prev, sub_caste_id: "" }));
    //   //const castesData = commResult.filter(item => item.comm_type === 'CST' && item.under_comm_id === Number(value));
    //   const castesData = commResult.filter(item => item.comm_type === 'CST');
    //   setDdlCastes(castesData);
    // } else if (name === 'caste_id') {
    //   setDdlSubCastes([]);
    //   setFormData(prev => ({ ...prev, sub_caste_id: "" }));
    //   //const subcastesData = commResult.filter(item => item.comm_type === 'SCST' && item.under_comm_id === Number(value));
    //   const subcastesData = commResult.filter(item => item.comm_type === 'SCST');
    //   setDdlSubCastes(subcastesData);
    // }

    setErrors(prev => ({
      ...prev,
      [name]: ""
    }));

  };

  const handleBlur = (e) => {

    const { name, value } = e.target;

    if (name === 'curr_address1') {
      if (!formData.perm_address1 || formData.perm_address1 === '') {
        setFormData(prev => ({ ...prev, perm_address1: value }))
      }
    } else if (name === 'curr_address2') {
      if (!formData.perm_address2 || formData.perm_address2 === '') {
        setFormData(prev => ({ ...prev, perm_address2: value }))
      }
    }

  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSavedImage('');
    setFile(file);
    setFormData(prev => ({ ...prev, pic_name: file?.name || '' }));
  };

  const handleParentFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setSavedImage('');
    setParentFile(selectedFile);

    setFormData(prev => ({
      ...prev,
      parent_pic: selectedFile?.name || ''
    }));
  };


  // const handleAcademicYear = (e) => {
  //   const yr = ddlAcademicYear.find(x => x.year1 === e.target.value);
  //   if (!yr) return;
  //   setFormData(prev => ({
  //     ...prev,
  //     academic_year1: yr.y1,
  //     academic_year2: yr.y2
  //   }));
  // };

  const handleNew = () => {
    setFormData(initialFormData);
    setIsEditable(true);
    setSavedImage('');
  };

  const handleClear = () => {
    if (!window.confirm("Clear form?")) return;
    setFormData(initialFormData);
    setIsEditable(false);
    setFile(null);
    setParentFile(null);
    setSavedImage('');
  };

  const handleSave = async () => {

    const newErrors = {};

    if (!formData.section_id) {
      newErrors.section_id = "Error";
      toast.error("Please select Section.");
    }
    else if (!formData.academic_year1) {
      newErrors.academic_year1 = "Error";
      toast.error("Please select Academic Year.");
    } 
    else if (!formData.stud_first_name) {
      newErrors.stud_first_name = "Error";
      toast.error("Please enter Student First Name.");
    } else if (!formData.stud_last_name) {
      newErrors.stud_last_name = "Error";
      toast.error("Please enter Student Last Name.");
    } else if (!formData.student_id) {
      newErrors.student_id = "Error";
      toast.error("Please enter PEN No.");
    } else if (!formData.form_no) {
      newErrors.form_no = "Error";
      toast.error("Please enter Form No.");
    } else if (!formData.birth_date) {
      newErrors.birth_date = "Error";
      toast.error("Please enter Birth Date.");
    } else if (!formData.birth_place) {
      newErrors.birth_place = "Error";
      toast.error("Please enter Birth Place.");
    } else if (!formData.gender_id) {
      newErrors.gender_id = "Error";
      toast.error("Please select Gender.");
    } else if (!formData.curr_std_id) {
      newErrors.curr_std_id = "Error";
      toast.error("Please select Current Standard.");
    } else if (!formData.curr_div_id) {
      newErrors.curr_div_id = "Error";
      toast.error("Please select Current Division.");
    } else if (!formData.adm_std_id) {
      newErrors.adm_std_id = "Error";
      toast.error("Please select Admitted Standard.");
    } else if (!formData.adm_div_id) {
      newErrors.adm_div_id = "Error";
      toast.error("Please select Admitted Division.");
    } else if (!formData.adm_date) {
      newErrors.adm_date = "Error";
      toast.error("Please enter Admission Date.");
    } else if (!formData.email_for_corrsp) {
      newErrors.email_for_corrsp = "Error";
      toast.error("Please enter eMail Id.");
    } else if (!formData.mobile_for_sms) {
      newErrors.mobile_for_sms = "Error";
      toast.error("Please enter Mobile (SMS).");
    } else if (!formData.curr_address1) {
      newErrors.curr_address1 = "Error";
      toast.error("Please enter Current Address Line 1.");
    } else if (!formData.perm_address1) {
      newErrors.perm_address1 = "Error";
      toast.error("Please enter Permanent Address Line 1.");
    } else if (!formData.father_first_name) {
      newErrors.father_first_name = "Error";
      toast.error("Please enter Father First Name.");
    } else if (!formData.father_age) {
      newErrors.father_age = "Error";
      toast.error("Please enter Father Age.");
    } else if (!formData.mother_first_name) {
      newErrors.mother_first_name = "Error";
      toast.error("Please enter Mother First Name.");
    } else if (!formData.mother_age) {
      newErrors.mother_age = "Error";
      toast.error("Please enter Mother Age.");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      if (firstErrorKey) {
        const el = document.getElementsByName(firstErrorKey)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus(); // 🔥 bonus (cursor goes there)
        }
      }
      return;
    }

    //else if (!formData.stud_middle_name) {
    //   toast.error("Please enter Student Middle Name.");
    //   return;
    // }

    if (!window.confirm("Save Student record ?")) return;

    try {

      const response = await axios.post(`${BASE_URL}/api/save_student`, formData);

      if (response.data.message !== '0') {
        ///// Start : Uploading Student Pic to API folder
        let new_gr_no = response.data.message;
        if (file) {
          try {
            const photoData = new FormData();
            photoData.append("file", file);
            photoData.append("section_id", formData.section_id);
            photoData.append("gr_no", new_gr_no);
            await axios.post(`${BASE_URL}/api/upload_Stud_Pic`, photoData);
          } catch (err) {
            console.log('Error uploading Student Photo : ', err);
          }
        }
        ///// End : Uploading Student Pic to API folder
        ///// Start : Uploading Parent Pic to API folder
        if (parentfile) {
          try {
            const photoData = new FormData();
            photoData.append("parentfile", parentfile);
            photoData.append("section_id", formData.section_id);
            photoData.append("gr_no", new_gr_no);
            await axios.post(`${BASE_URL}/api/upload_Parent_Pic`, photoData);
          } catch (err) {
            console.log('Error uploading Parent Photo : ', err);
          }
        }
        ///// End : Uploading Parent Pic to API folder
        ///// Start : Uploading LC/BC File to API folder
        if (lcbcFile) {
          try {
            const lcData = new FormData();
            lcData.append("lcfile", lcbcFile);
            lcData.append("section_id", formData.section_id);
            lcData.append("gr_no", new_gr_no);
            await axios.post(
              `${BASE_URL}/api/upload_LC_BC`,
              lcData
            );
          } catch (err) {
            console.log("Error uploading LC/BC File : ", err);
          }
        }
        ///// End : Uploading LC/BC File to API folder

        ///// Start : Uploading Aadhar File to API folder
        if (aadharFile) {
          try {
            const aadharData = new FormData();
            aadharData.append("aadharfile", aadharFile);
            aadharData.append("section_id", formData.section_id);
            aadharData.append("gr_no", new_gr_no);
            await axios.post(
              `${BASE_URL}/api/upload_Aadhar`,
              aadharData
            );

          } catch (err) {
            console.log("Error uploading Aadhar File : ", err);
          }
        }
        ///// End : Uploading Aadhar File to API folder
        toast.success('Saved Successfully. GR No. ' + response.data.message);
        //alert('Saved Successfully. GR No. ' + response.data.message);
        setFormData(initialFormData);
        //alert("Student saved successfully");
        setIsEditable(false);
        setFile(null);
        setParentFile(null);
        setLCBCFile(null);
        setAadharFile(null);
        setPdfURL(null);
        setAadharPdfURL(null);
        setSavedImage('');
      }

    } catch (err) {
      console.error(err);
      toast.error("Error saving student");
    }

  };

  // const handleUpload_LC_BC = (e) => {

  //   const file = e.target.files[0];

  //   if (!file) return;

  //   setLCBCFiles(e.target.files);

  //   const previewURL = URL.createObjectURL(file);
  //   setPdfURL(previewURL);

  //   setFormData(prev => ({
  //     ...prev,
  //     pdfFile: file
  //   }));

  // };

  const handleUpload_LC_BC = (e) => {

    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    setLCBCFile(selectedFile);

    const previewURL = URL.createObjectURL(selectedFile);
    setPdfURL(previewURL);

  };

  // const handleUpload_Aadhar = (e) => {

  //   const file = e.target.files[0];

  //   if (!file) return;

  //   setAadharFiles(e.target.files);

  //   const previewURL = URL.createObjectURL(file);
  //   setAadharPdfURL(previewURL);

  //   setFormData(prev => ({
  //     ...prev,
  //     pdfFile: file
  //   }));

  // };

  const handleUpload_Aadhar = (e) => {

    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    setAadharFile(selectedFile);

    const previewURL = URL.createObjectURL(selectedFile);
    setAadharPdfURL(previewURL);

  };

  /// Float button to go to top of the page
  useEffect(() => {

    const container = containerRef.current;

    const handleScroll = () => {
      setShowButton(container.scrollTop > 300);
    };

    container.addEventListener("scroll", handleScroll);

    return () => container.removeEventListener("scroll", handleScroll);

  }, []);

  const scrollToTop = () => {

    containerRef.current.scrollTo({
      top: 0,
      behavior: "smooth",
    });

  };

  return (
    // <Container fluid className="p-3" style={{ maxHeight: "90vh", overflowY: "auto" }}>
    <Container ref={containerRef} fluid className="p-3" style={{ maxHeight: "90vh", overflowY: "auto" }} >

      {/* ================= PERSONAL DETAILS ================= */}
      <Card className="mb-4">
        <Card.Header
          className="fw-bold" style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          🎓 Student's Personal Details
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={8}>
              <Row className="mb-3">

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Section<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <select name="section_id"
                      // className="form-select"
                      className={`form-select ${errors.section_id ? "is-invalid" : ""}`}
                      value={formData.section_id} onChange={handleChange} disabled={!isEditable}>
                      <option value="">--Select Section--</option>
                      {ddlSections.map(s => (
                        <option key={s.section_id} value={s.section_id}>{s.section_desc}</option>
                      ))}
                    </select>
                  </InputGroup>
                </Col>

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Academic Year <span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <select name="academic_year1" value={formData.academic_year1}
                      className={`form-select ${errors.academic_year1 ? "is-invalid" : ""}`}
                      onChange={handleChange} disabled={!isEditable}>
                      <option value="">--Select Acadamic Year--</option>
                      {ddlAcademicYears.map(y => (
                        <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                      ))}
                    </select>
                  </InputGroup>
                </Col>

              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>First Name<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="stud_first_name" placeholder="First Name"
                      className={`form-control ${errors.stud_first_name ? "is-invalid" : ""}`}
                      // className="form-control"
                      value={formData.stud_first_name} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Middle Name</InputGroup.Text>
                    <input name="stud_middle_name" placeholder="Middle Name" className="form-control"
                      value={formData.stud_middle_name} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Last Name<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="stud_last_name" placeholder="Last Name"
                      className={`form-control ${errors.stud_last_name ? "is-invalid" : ""}`} //className="form-control"
                      value={formData.stud_last_name} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>GR NO. </InputGroup.Text>
                    <input name="gr_no" className="form-control"
                      value={formData.gr_no} onChange={handleChange} disabled />
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Aadhar No.</InputGroup.Text>
                    <input name="aadhar_no" placeholder="Adhar Number" className="form-control"
                      value={formData.aadhar_no} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>PEN No<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="student_id" placeholder="Student ID"
                      className={`form-control ${errors.student_id ? "is-invalid" : ""}`} //className="form-control"
                      value={formData.student_id} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Form<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="form_no" placeholder="Form No "
                      className={`form-control ${errors.form_no ? "is-invalid" : ""}`}
                      value={formData.form_no} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Birth Date<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input type="date" name="birth_date"
                      className={`form-control ${errors.birth_date ? "is-invalid" : ""}`}
                      value={formData.birth_date} onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
              </Row>

            </Col>
            {/* ************************************************************************************************************************************* */}
            {/* ********************************************  Start : Photo Section   *************************************************************** */}
            {/* <Col md={1} ></Col> */}
            <Col md={3} className="text-center">

              <div style={{ border: "1px solid #ccc", padding: "10px" }}>
                <div>
                  <strong>Student Photo</strong>
                </div>
                <div style={{ height: "180px", background: "#f8f9fa", display: "flex", alignItems: "center", justifyContent: "center", border: "1px dashed #aaa" }}
                // className="my-2"
                >
                  {file ? (
                    <img src={URL.createObjectURL(file)} alt="preview" style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", display: "block" }} />
                  ) : savedImage ? <img src={savedImage} alt="saved" style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", display: "block" }} /> :
                    (
                      <div style={{ height: "150px", background: "#f8f9fa", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        No Image
                      </div>
                    )}
                </div>
                <input type="file" className="form-control" onChange={handleFileChange}
                  disabled={!isEditable} style={{ marginTop: "5px" }} ref={fileInputRef} />
              </div>
            </Col>

            {/* **********************************************  End : Photo Section   *************************************************************** */}
            {/* ************************************************************************************************************************************* */}


          </Row>
          {/* <br /> */}

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Birth Place<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input name="birth_place" placeholder="Birth Place"
                  className={`form-control ${errors.birth_place ? "is-invalid" : ""}`}
                  value={formData.birth_place} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Gender<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="gender_id"
                  className={`form-select ${errors.gender_id ? "is-invalid" : ""}`}
                  value={formData.gender_id} onChange={handleChange} disabled={!isEditable}>
                  <option value="0">-- Select Gender --</option>
                  {ddlGender.map(g => (
                    <option key={g.comm_id} value={g.comm_id}>{g.comm_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4} style={{marginTop: "5px"}}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Fees Type</InputGroup.Text>
                <select name="mthly_install" className="form-select"
                  value={formData.mthly_install} onChange={handleChange} disabled={!isEditable}>
                  {ddlMthlyInst.map(y => <option key={y.id} value={y.id}>{y.name}</option>)}
                </select>
              </InputGroup>
            </Col>

          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Current Std <span style={{ color: "red" }}>*</span> </InputGroup.Text>
                <select name="curr_std_id"
                  className={`form-select ${errors.curr_std_id ? "is-invalid" : ""}`}
                  value={formData.curr_std_id} onChange={handleChange} disabled={!isEditable}>
                  <option value="">--Select Current Std --</option>
                  {ddlStandards.map(std => (
                    <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Current Div <span style={{ color: "red" }}>*</span> </InputGroup.Text>
                <select name="curr_div_id" className={`form-select ${errors.curr_div_id ? "is-invalid" : ""}`}
                  value={formData.curr_div_id} onChange={handleChange} disabled={!isEditable}>
                  <option value="">--Select Current Div --</option>
                  {ddlDivisions.map(div => (
                    <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Status</InputGroup.Text>
                <select name="status" className="form-select"
                  value={formData.status} onChange={handleChange} disabled={!isEditable}>
                  {ddlStatus.map(s => (
                    <option key={s.id} value={s.id}>{s.name}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Adm Std <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="adm_std_id" className={`form-select ${errors.adm_std_id ? "is-invalid" : ""}`}
                  value={formData.adm_std_id} onChange={handleChange} disabled={!isEditable}>
                  <option value="">--Select Admission Std --</option>
                  {ddlStandards.map(std => (
                    <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Adm Div <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <select name="adm_div_id" className={`form-select ${errors.adm_div_id ? "is-invalid" : ""}`}
                  value={formData.adm_div_id} onChange={handleChange} disabled={!isEditable}>
                  <option value="">--Select Admission Div --</option>
                  {ddlDivisions.map(div => (
                    <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Admission Date <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input type="date" name="adm_date" className={`form-control ${errors.adm_date ? "is-invalid" : ""}`}
                  value={formData.adm_date} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Email ID <span style={{ color: "red" }}>*</span> </InputGroup.Text>
                <input name="email_for_corrsp" placeholder="Email"
                  className={`form-control ${errors.email_for_corrsp ? "is-invalid" : ""}`}
                  value={formData.email_for_corrsp} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Mobile(SMS) <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input name="mobile_for_sms" placeholder="Mobile (SMS)"
                  className={`form-control ${errors.mobile_for_sms ? "is-invalid" : ""}`}
                  value={formData.mobile_for_sms} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Optional Subject</InputGroup.Text>
                <input name="opt_sub_id" className="form-control"
                  value={formData.opt_sub_id} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          {/* ================= ACTIONS ================= */}

          <Row className="mb-3">

            <Col md={12}>

              <div className="text-end">
                <button
                  className="btn btn-primary me-2"
                  style={{ width: "135px" }}
                  onClick={handleNew}
                  disabled={isEditable}>
                  New
                </button>

                <button
                  className="btn btn-secondary me-2"
                  style={{ width: "135px" }}
                  onClick={handleClear}>
                  Clear
                </button>

                <button
                  className="btn btn-success"
                  style={{ width: "135px" }}
                  onClick={handleSave}
                  disabled={!isEditable}>
                  Save
                </button>
              </div>
            </Col>
          </Row>

        </Card.Body>

      </Card>

      {/* ================= COMMUNICATION ================= */}


      {/* `<Card className="mb-3 p-3"> */}
      <Card className="mb-4">
        <Card.Header className="fw-bold" style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          🏠 Communication Details
        </Card.Header>
        <Card.Body>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Current Add 1 <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input name="curr_address1" placeholder="Current Address 1"
                  className={`form-control ${errors.curr_address1 ? "is-invalid" : ""}`}
                  onBlur={handleBlur}
                  value={formData.curr_address1} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Current Add 2 </InputGroup.Text>
                <input name="curr_address2" placeholder="Current Address 2" className="form-control" onBlur={handleBlur}
                  value={formData.curr_address2} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "100px" }}> Pin </InputGroup.Text>
                <input name="curr_pin_code" placeholder="PIN" className="form-control"
                  value={formData.curr_pin_code} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "100px" }}> Tel </InputGroup.Text>
                <input name="curr_telephone" placeholder="Telephone" className="form-control"
                  value={formData.curr_telephone} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "160px" }}> Permanent Add 1 <span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input name="perm_address1" placeholder="Permanent Address 1"
                  className={`form-control ${errors.perm_address1 ? "is-invalid" : ""}`}
                  value={formData.perm_address1} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "160px" }}> Permanent Add 2 </InputGroup.Text>
                <input name="perm_address2" placeholder="Permanent Address 2" className="form-control"
                  value={formData.perm_address2} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            {/* <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> State </InputGroup.Text>
                <input name="perm_state_id" placeholder="State" className="form-control"
                  value={formData.perm_state_id} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col> */}

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> District </InputGroup.Text>
                <input name="perm_district" placeholder="District" className="form-control"
                  value={formData.perm_district} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Taluka </InputGroup.Text>
                <input name="perm_taluka" placeholder="Taluka" className="form-control"
                  value={formData.perm_taluka} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}> Pin </InputGroup.Text>
                <input name="perm_pin_code" placeholder="PIN" className="form-control"
                  value={formData.perm_pin_code} onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ================= Parent Table ================= */}

      {/* <Card className="mb-3 p-3"> */}
      <Card className="mb-4">
        <Card.Header
          className="fw-bold"
          style={{ backgroundColor: "#e0a575", color: "black" }}>
          👨‍👩‍👧Parent Details
        </Card.Header>
        <Card.Body>

          {/* ================= FATHER DETAILS ================= */}

          <h6 style={{ color: "#1c39df" }}><u>Father Details</u></h6>
          <Row>
            <Col md={8}>
              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>First Name<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="father_first_name"
                      className={`form-control ${errors.father_first_name ? "is-invalid" : ""}`}
                      value={formData.father_first_name || ""}
                      onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Last Name</InputGroup.Text>
                    <input name="father_last_name" className="form-control"
                      value={formData.father_last_name || ""}
                      onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Aadhar No.</InputGroup.Text>
                    <input name="father_aadhar" className="form-control"
                      value={formData.father_aadhar || ""}
                      onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>

                </Col>
                
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Age<span style={{ color: "red" }}>*</span></InputGroup.Text>
                    <input name="father_age" className={`form-control ${errors.father_age ? "is-invalid" : ""}`}
                      value={formData.father_age || ""}
                      onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>

              </Row>

              <Row className="mb-3">

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Mobile</InputGroup.Text>
                    <input name="father_cell_no" className="form-control"
                      value={formData.father_cell_no || ""}
                      onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Email</InputGroup.Text>
                    <input name="father_email_id" className="form-control"
                      value={formData.father_email_id || ""}
                      onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>

              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Qualification</InputGroup.Text>
                    <select name="father_qual_id" className="form-select"
                      value={formData.father_qual_id || ""}
                      onChange={handleChange} disabled={!isEditable}>
                      <option value="0">-- Select Qualification --</option>
                      {ddlQualifications.map(g => (
                        <option key={g.comm_id} value={g.comm_id}>{g.comm_desc}</option>
                      ))}
                    </select>
                  </InputGroup>
                </Col>

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Occupation</InputGroup.Text>
                    <select name="father_occp_id" className="form-select"
                      value={formData.father_occp_id || ""}
                      onChange={handleChange} disabled={!isEditable}>
                      <option value="0">-- Select Occupation --</option>
                      {ddlOccupations.map(g => (
                        <option key={g.comm_id} value={g.comm_id}>{g.comm_desc}</option>
                      ))}
                    </select>
                  </InputGroup>
                </Col>
              </Row>

              <Row className="mb-3">

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Firm Name</InputGroup.Text>
                    <input
                      name="father_firm_name"
                      className="form-control"
                      value={formData.father_firm_name || ""}
                      onChange={handleChange}
                      disabled={!isEditable}
                    />
                  </InputGroup>
                </Col>

                <Col md={6}>

                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Firm Address</InputGroup.Text>
                    <input
                      name="father_firm_addr"
                      className="form-control"
                      value={formData.father_firm_addr || ""}
                      onChange={handleChange}
                      disabled={!isEditable}
                    />
                  </InputGroup>

                </Col>

              </Row>

              <Row className="mb-3">

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Designation</InputGroup.Text>
                    <input name="father_designation" className="form-control"
                      value={formData.father_designation || ""}
                      onChange={handleChange} disabled={!isEditable} />
                  </InputGroup>
                </Col>

                <Col md={6}>
                  <InputGroup>
                    <InputGroup.Text style={{ width: "140px" }}>Firm Tel</InputGroup.Text>
                    <input
                      name="father_firm_tel"
                      className="form-control"
                      value={formData.father_firm_tel || ""}
                      onChange={handleChange}
                      disabled={!isEditable}
                    />
                  </InputGroup>

                </Col>

              </Row>

            </Col>
            {/* ************************************************************************************************************************************* */}
            {/* ********************************************  Start : Photo Section   *************************************************************** */}
            <Col md={3} className="text-center">

              <div style={{ border: "1px solid #ccc", padding: "10px" }}>
                <div>
                  <strong>Family Photo</strong>
                </div>
                <div style={{ height: "200px", background: "#f8f9fa", display: "flex", alignItems: "center", justifyContent: "center", border: "1px dashed #aaa" }}
                // className="my-2"
                >
                  {parentfile ? (
                    <img src={URL.createObjectURL(parentfile)} alt="preview" style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", display: "block" }} />
                  ) : savedImage ? <img src={savedImage} alt="saved" style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", display: "block" }} /> :
                    (
                      <div style={{ height: "200px", background: "#f8f9fa", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        No Image
                      </div>
                    )}
                </div>
                <input type="file" className="form-control" onChange={handleParentFileChange}
                  disabled={!isEditable} style={{ marginTop: "15px" }} ref={parentfileInputRef} />
              </div>
            </Col>

            {/* **********************************************  End : Photo Section   *************************************************************** */}
            {/* ************************************************************************************************************************************* */}
          </Row>

          <hr />

          <h6 style={{ color: "#C2185B" }}><u>Mother Details</u></h6>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>First Name<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input name="mother_first_name" className={`form-control ${errors.mother_first_name ? "is-invalid" : ""}`}
                  value={formData.mother_first_name || ""}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Last Name</InputGroup.Text>
                <input name="mother_last_name" className="form-control"
                  value={formData.mother_last_name || ""}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Aadhar No.</InputGroup.Text>
                <input name="mother_aadhar" className="form-control"
                  value={formData.mother_aadhar}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>

            </Col>
          </Row>

          <Row className="mb-3">

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Age<span style={{ color: "red" }}>*</span></InputGroup.Text>
                <input name="mother_age" className={`form-control ${errors.mother_age ? "is-invalid" : ""}`}
                  value={formData.mother_age || ""}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Mobile</InputGroup.Text>
                <input name="mother_cell_no" className="form-control"
                  value={formData.mother_cell_no || ""}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>

              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Email</InputGroup.Text>
                <input name="mother_email_id" className="form-control"
                  value={formData.mother_email_id || ""}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>

            </Col>

          </Row>

          <Row className="mb-3">

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Qualification</InputGroup.Text>
                <select name="mother_qual_id" className="form-select"
                  value={formData.mother_qual_id || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="0">-- Select Qualification --</option>
                  {ddlQualifications.map(g => (
                    <option key={g.comm_id} value={g.comm_id}>{g.comm_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Occupation</InputGroup.Text>
                <select name="mother_occp_id" className="form-select"
                  value={formData.mother_occp_id || ""}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="0">-- Select Occupation --</option>
                  {ddlOccupations.map(g => (
                    <option key={g.comm_id} value={g.comm_id}>{g.comm_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Firm Name</InputGroup.Text>
                <input
                  name="mother_firm_name"
                  className="form-control"
                  value={formData.mother_firm_name || ""}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

          </Row>

          <Row className="mb-3">

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Firm Address</InputGroup.Text>
                <input
                  name="mother_firm_address"
                  className="form-control"
                  value={formData.mother_firm_address || ""}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Firm Tel</InputGroup.Text>
                <input
                  name="mother_firm_tel"
                  className="form-control"
                  value={formData.mother_firm_tel || ""}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Designation</InputGroup.Text>
                <input name="mother_designation" className="form-control"
                  value={formData.mother_designation || ""}
                  onChange={handleChange} disabled={!isEditable} />
              </InputGroup>
            </Col>

          </Row>
        </Card.Body>
      </Card>


      ***********************************Medical Information*********************************

      <Card className="mb-4">
        <Card.Header
          className="fw-bold"
          style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          🩺 Student Medical History
        </Card.Header>
        <Card.Body>

          <h6 className="text-primary"><u>Medical Basic Information</u></h6>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "160px" }}>Blood Group</InputGroup.Text>
                <select className="form-select" name="blood_group"
                  value={formData.blood_group}
                  onChange={handleChange} disabled={!isEditable} >
                  <option value="">-- Select --</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "180px" }}>Hearing</InputGroup.Text>
                <select className="form-select"
                  name="hearing" value={formData.hearing}
                  onChange={handleChange}
                  disabled={!isEditable}
                >
                  <option value="">-- Select --</option>
                  <option value="N">Normal</option>
                  <option value="I">Issue</option>
                </select>
              </InputGroup>
            </Col>

            {/* <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>Physical Disability</InputGroup.Text>
                <select className="form-select"
                  name="physical_disability" value={formData.physical_disability}
                  onChange={handleChange}
                  disabled={!isEditable}>
                  <option value="">-- Select --</option>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </InputGroup>
            </Col> */}

          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "160px" }}>Height Ft (Adm)</InputGroup.Text>
                <input className="form-control" type="number" style={{ textAlign: "right" }}
                  onChange={handleChange} value={formData.height_admission} name='height_admission'
                  disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "180px" }}>Height Ft (Current)</InputGroup.Text>
                <input className="form-control" type="number" style={{ textAlign: "right" }}
                  onChange={handleChange} value={formData.height_current} name='height_current'
                  disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "160px" }}>Weight KG (Adm)</InputGroup.Text>
                <input className="form-control" type="number" style={{ textAlign: "right" }}
                  onChange={handleChange} value={formData.weight_admission} name='weight_admission'
                  disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "180px" }}>Weight KG (Current)</InputGroup.Text>
                <input className="form-control" type="number" style={{ textAlign: "right" }}
                  onChange={handleChange} value={formData.weight_current} name='weight_current'
                  disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>
          <hr />

          <h6 className="text-danger"><u>Medical Conditions</u></h6>

          <Row className="mb-3">
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Wear Glasses</InputGroup.Text>
                <select className="form-select" name="wear_glasses"
                  value={formData.wear_glasses}
                  onChange={handleChange} disabled={!isEditable} >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={9}>
              <InputGroup>
                <InputGroup.Text style={{ width: "300px" }}>Wear Glasses All Times/Classroom</InputGroup.Text>
                <input className="form-control" type="text" style={{ textAlign: "left" }}
                  onChange={handleChange} value={formData.glasses_details} name='glasses_details'
                  disabled={!isEditable} />
              </InputGroup>
            </Col>

          </Row>

          <Row className="mb-3">

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Heart Condition</InputGroup.Text>
                <select className="form-select"
                  name="heart_condition" value={formData.heart_condition}
                  onChange={handleChange}
                  disabled={!isEditable}>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={9}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Illness Details</InputGroup.Text>
                <input
                  className="form-control"
                  name="heart_details" value={formData.heart_details}
                  placeholder="Enter Heart details if Yes"
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

          </Row>

          {/* Chronic Illness */}
          <Row className="mb-3">
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Chronic Illness</InputGroup.Text>
                <select className="form-select"
                  name="chronic_illness" value={formData.chronic_illness}
                  onChange={handleChange}
                  disabled={!isEditable}>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={9}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Illness Details</InputGroup.Text>
                <input
                  className="form-control"
                  name="illness_details" value={formData.illness_details}
                  placeholder="Enter illness details if Yes"
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          {/* Allergies */}
          <Row className="mb-3">
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Allergies</InputGroup.Text>
                <select className="form-select"
                  name="allergies" value={formData.allergies}
                  onChange={handleChange}
                  disabled={!isEditable}>
                  <option value="FOOD">Food</option>
                  <option value="MEDICINE">Medicine</option>
                  <option value="DUST">Dust</option>
                  <option value="INSECT">Insect</option>
                  <option value="N">No Allergy</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={9}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Allergy Details</InputGroup.Text>
                <input
                  className="form-control"
                  name="allergy_details" value={formData.allergy_details}
                  placeholder="Specify allergy details"
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          {/* Asthma / Diabetes / Epilepsy / Heart */}
          <Row className="mb-3">
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Asthma</InputGroup.Text>
                <select className="form-select"
                  name="asthma" value={formData.asthma}
                  onChange={handleChange}
                  disabled={!isEditable}>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Diabetes</InputGroup.Text>
                <select className="form-select"
                  name="diabetes" value={formData.diabetes}
                  onChange={handleChange}
                  disabled={!isEditable}>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "100px" }}>Epilepsy</InputGroup.Text>
                <select className="form-select"
                  name="epilepsy" value={formData.epilepsy}
                  onChange={handleChange}
                  disabled={!isEditable}>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </InputGroup>
            </Col>

          </Row>

          {/* Regular Medication */}

          <Row className="mb-3">

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "155px" }}>Regular Medication</InputGroup.Text>
                <select className="form-select"
                  name="regular_medication" value={formData.regular_medication}
                  onChange={handleChange}
                  disabled={!isEditable}>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </InputGroup>
            </Col>

            <Col md={8}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Medical Remarks</InputGroup.Text>
                <textarea
                  className="form-control"
                  name="medical_remarks" value={formData.medical_remarks}
                  rows="1"
                  placeholder="Any additional medical notes"
                  onChange={handleChange}
                  disabled={!isEditable}
                ></textarea>
              </InputGroup>
            </Col>

          </Row>
          <hr />


          <h6 className="text-warning"><u>Emergency Medical Contact</u></h6>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Contact Name</InputGroup.Text>
                <input className="form-control" value={formData.emg_cont_name} name="emg_cont_name"
                  onChange={handleChange}
                  disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "90px" }}>Relation</InputGroup.Text>
                <input className="form-control" value={formData.emg_cont_relation} name="emg_cont_relation"
                  onChange={handleChange}
                  disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Contact Number</InputGroup.Text>
                <input className="form-control" value={formData.emg_cont_number} name="emg_cont_number"
                  onChange={handleChange}
                  disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Doctor Name</InputGroup.Text>
                <input className="form-control" value={formData.doctor_name} name="doctor_name"
                  onChange={handleChange}
                  disabled={!isEditable} />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Doctor Number</InputGroup.Text>
                <input className="form-control" value={formData.doctor_number} name="doctor_number"
                  onChange={handleChange}
                  disabled={!isEditable} />
              </InputGroup>
            </Col>
          </Row>

        </Card.Body>
      </Card>

      {/* ================= OTHER DETAILS =================  */}

      <Card className="mb-4">
        <Card.Header className="fw-bold" style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          📋Other Details
        </Card.Header>
        <Card.Body>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Religion</InputGroup.Text>
                <select name="religion_id" className="form-select"
                  value={formData.religion_id}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="0">-- Select Religion --</option>
                  {ddlReligions.map(g => (
                    <option key={g.comm_id} value={g.comm_id}>{g.comm_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Caste</InputGroup.Text>
                <select name="caste_id" className="form-select"
                  value={formData.caste_id}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="0">-- Select Caste --</option>
                  {ddlCastes.map(g => (
                    <option key={g.comm_id} value={g.comm_id}>{g.comm_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Sub-Caste</InputGroup.Text>
                <select name="sub_caste_id" className="form-select"
                  value={formData.sub_caste_id}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="0">-- Select Sub-Caste --</option>
                  {ddlSubCastes.map(g => (
                    <option key={g.comm_id} value={g.comm_id}>{g.comm_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>House</InputGroup.Text>
                <select name="house_id" className="form-select"
                  value={formData.house_id}
                  onChange={handleChange} disabled={!isEditable}>
                  <option value="0">-- Select House --</option>
                  {ddlHouses.map(g => (
                    <option key={g.comm_id} value={g.comm_id}>{g.comm_desc}</option>
                  ))}
                </select>
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Nationality</InputGroup.Text><input
                  name="nationality"
                  placeholder="Nationality"
                  className="form-control"
                  value={formData.nationality}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>Mother Tongue</InputGroup.Text>
                <input
                  name="mother_tongue"
                  placeholder="Mother Tongue"
                  className="form-control"
                  value={formData.mother_tongue}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          <hr />

          <Row className="mb-3">

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "180px" }}>Last School Name</InputGroup.Text>
                <input
                  name="last_school_name"
                  placeholder="Last School Name"
                  className="form-control"
                  value={formData.last_school_name}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "180px" }}>Last School Std</InputGroup.Text>
                <input
                  name="last_school_std"
                  placeholder="Last School Std"
                  className="form-control"
                  value={formData.last_school_std}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

          </Row>

          <Row className="mb-3">

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "180px" }}>Last School Addr1</InputGroup.Text>
                <input
                  name="last_school_addr1"
                  placeholder="Last School Address Line 1"
                  className="form-control"
                  value={formData.last_school_addr1}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "180px" }}>Last School Addr2</InputGroup.Text>
                <input
                  name="last_school_addr2"
                  placeholder="Last School Address Line 2"
                  className="form-control"
                  value={formData.last_school_addr2}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

          </Row>

          <hr />

          <Row className="mb-3">

            {/* LC/BC Upload */}
            <Col md={6}>
              <Form.Label>Select LC/BC File :</Form.Label>
              <Form.Control type="file" accept="image/*" onChange={handleUpload_LC_BC} ref={fileInputRef} id="formFileSm" />

              {pdfURL && (
                <div className="mt-3">
                  <h6>LC/BC Preview:</h6>
                  {/* <iframe
                    src={pdfURL}
                    title="LC/BC Preview"
                    width="100%"
                    height="400px"
                    style={{ border: "1px solid #ccc" }}
                  ></iframe> */}
                  <img
                    src={pdfURL}
                    alt="LC/BC Preview"
                    style={{
                      width: "100%",
                      height: "300px",
                      objectFit: "contain",
                      border: "1px solid #ccc"
                    }} />
                </div>
              )}
            </Col>

            {/* Aadhar Upload */}
            <Col md={6}>
              <Form.Label>Select Aadhar File :</Form.Label>
              <Form.Control type="file" accept="image/*" onChange={handleUpload_Aadhar} ref={fileInputRef} id="formFileSm" />

              {aadharpdfURL && (
                <div className="mt-3">
                  <h6>Aadhar Preview:</h6>
                  {/* <iframe
                    src={aadharpdfURL}
                    title="Aadhar Preview"
                    width="100%"
                    height="500px"
                    style={{ border: "1px solid #ccc" }}
                  ></iframe> */}
                  <img
                    src={aadharpdfURL}
                    alt="Aadhar Preview"
                    style={{
                      width: "100%",
                      height: "300px",
                      objectFit: "contain",
                      border: "1px solid #ccc"
                    }} />
                </div>
              )}
            </Col>

          </Row>

        </Card.Body>
      </Card>

      {showButton && (
        <button
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "25px",
            right: "25px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            border: "none",
            background: "#0d6efd",
            color: "#fff",
            fontSize: "22px",
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            zIndex: 9999
          }}
          title="Back to Top"
        >
          ↑
        </button>
      )}

    </Container>
  );
};
export default NewStudent;
